export const getEspecieSilvicultura = (state) => state.especieSilvicultura.lista
export const getIsCarregandoListaEspecieSilvicultura =
  (state) => state.especieSilvicultura.isCarregandoLista
export const getIsSavingEspecieSilvicultura = (state) => state.especieSilvicultura.isSaving
export const getIsUpdatingEspecieSilvicultura = (state) => state.especieSilvicultura.isUpdate
